import { BrowserRouter as Router, Route, Routes } from "react-router";
import { Home, Layout, About } from "./pages";
import ScrollToTop from "./components/ScrollToTop";
import OurFood from "./pages/ourFood";
import Contacto from "./pages/home/components/Contacto";

export default function VeganVegetarianRoutes() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home/>} />
          <Route path="/about" element={<About/>} />
          <Route path="/ourFood" element={<OurFood/>} />
          <Route path="/Contact" element={<Contacto/>} />
        </Route>
      </Routes>
    </Router>
  );
}
